<template>
  <div class="ui form" :id="'new-invoice-item-form-' + identifier">
    <div class="three fields">
      <div class="required field">
        <label for="item">Item</label>
        <select
          name="item"
          class="ui fluid dropdown"
          :id="'item_select_' + identifier"
          v-model="componentItem.item_id">
          <option value="">Item</option>
          <option :value="selectedItem.id" v-for="(selectedItem, index) in item.remainingItems" :key="'item-' + index">
            {{ selectedItem.name }}
          </option>
        </select>
      </div>

      <div class="required field">
        <label for="quantity">Quantity</label>
        <div class="ui input">
          <input type="number"
                 :placeholder="'Quantity'"
                 v-model="componentItem.quantity"
                 name="quantity">
        </div>
      </div>

      <div class="required field">
        <label for="unit_price">Unit Price</label>
        <div class="ui input">
          <input type="number"
                 :placeholder="'Unit Price'"
                 v-model="componentItem.unit_price"
                 name="unitPrice">
        </div>
      </div>

      <div class="field">
        <label for="label">Label</label>
        <div class="ui input">
          <input type="text"
                 :placeholder="'Label'"
                 v-model="componentItem.label"
                 name="label">
        </div>
      </div>

      <div class="field">
        <label for="expired_at">Expire at</label>
        <div style="text-align: center" class="ui calendar" :id="'expired_at_' + identifier">
          <div class="ui input left icon">
            <i class="calendar icon"></i>
            <input type="text"
                    :placeholder="'Expired at'"
                    readonly=""
                    name="Expired at">
          </div>
        </div>
      </div>

    </div>
    <div class="ui divider"></div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, required: true },
    identifier: { type: String, required: true },
    item: { type: Object, required: true },
    showError: { type: Boolean, default: false }
  },
  data () {
    return {
      componentItem: {}
    }
  },
  watch: {
    showError: {
      handler: function () {
        $('#new-invoice-item-form-' + this.identifier).form('submit')
      }
    },
    componentItem: {
      handler: function () {
        let isValid =
          this.componentItem.item_id && this.componentItem.quantity && this.componentItem.unit_price

        if (isValid) {
          this.$emit('invoice-item-changed', {
            data: {
              item: this.componentItem,
              valid: $('#new-invoice-item-form-' + this.identifier).form('is valid')
            }
          })
        }
      },
      deep: true
    }
  },
  mounted () {
    this.componentItem = this.item
    this.initGUI()
  },
  methods: {
    initGUI () {
      this.$nextTick(() => {
        $('#item_select_' + this.identifier).dropdown()

        $('#expired_at_' + this.identifier).calendar({
          type: 'date',
          minDate: new Date(),
          onChange: (date) => {
            this.componentItem.expired_at = date
          }
        })

        $.fn.form.settings.rules.inList = function (value, list) {
          return list.includes(value)
        }

        $('#new-invoice-item-form-' + this.identifier).form({
          inline: true,
          on: 'submit',
          fields: {
            item: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Choose the item you purchased and if it don\'t exist create it first.'
                }
              ]
            },
            quantity: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Enter the quantity you purchased.'
                },
                {
                  type: 'number',
                  prompt: 'Please enter valid quantity number.'
                }
              ]
            },
            unitPrice: {
              rules: [
                {
                  type: 'empty',
                  prompt: 'Please, Enter the unit price that you purchased on it.'
                },
                {
                  type: 'number',
                  prompt: 'Please, Enter valid price.'
                }
              ]
            }
          }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inventory_system/invoices/new_invoice_components/InvoiceEntry.vue